// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-colaboradores {
  padding: 0 5px;
}
.menu-colaboradores .menu-industry {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 10px;
  margin-bottom: 3rem;
}
.menu-colaboradores .menu-industry img {
  height: 150px;
  width: 150px;
}
.menu-colaboradores .search-colaborador {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 10px;
  padding: 0 10px;
  overflow: hidden;
  border: 2px solid;
}
.menu-colaboradores .search-colaborador input {
  margin: 0;
  width: 100%;
  border: none;
  border-radius: 0;
  padding: 0 5px;
  height: 30px;
  background: transparent;
}
.menu-colaboradores ul {
  padding: 10px;
  margin: 15px 0 0 0;
  list-style: none;
  height: calc(100vh - 203px);
  overflow-y: scroll;
}
.menu-colaboradores ul .active {
  opacity: 1;
}
.menu-colaboradores ul .active:hover {
  background: none;
}
.menu-colaboradores ul li {
  opacity: 0.5;
  border-bottom: 1px solid #d3d3d3;
  padding: 10px 0;
  display: flex;
  cursor: pointer;
}
.menu-colaboradores ul li img {
  width: 50px;
  height: 50px;
  margin: 0 25px;
  border-radius: 50rem;
}
.menu-colaboradores ul li .text h6 {
  font-weight: bold;
  padding: 0;
  margin: 0;
}
.menu-colaboradores ul li:hover {
  opacity: 1;
  background: #f6f6f6;
}`, "",{"version":3,"sources":["webpack://./src/Views/Analytics/Components/Menu/menuColaboradores.sass"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAAI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAER;AADQ;EACI,aAAA;EACA,YAAA;AAGZ;AADI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AADQ;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;AAGZ;AADI;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;AAGR;AADQ;EACI,UAAA;AAGZ;AAFY;EACI,gBAAA;AAIhB;AAFQ;EACI,YAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAIZ;AAFY;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAIhB;AADgB;EACI,iBAAA;EACA,UAAA;EACA,SAAA;AAGpB;AADY;EACI,UAAA;EACA,mBAAA;AAGhB","sourcesContent":[".menu-colaboradores\n    padding: 0 5px\n    & .menu-industry\n        position: relative\n        display: flex\n        justify-content: center\n        margin: 10px\n        margin-bottom: 3rem\n        & img\n            height: 150px\n            width: 150px\n\n    & .search-colaborador\n        display: flex\n        align-items: center\n        width: 100%\n        border-radius: 10px\n        padding: 0 10px\n        overflow: hidden\n        border: 2px solid\n\n        & input\n            margin: 0\n            width: 100%\n            border: none\n            border-radius: 0\n            padding: 0 5px\n            height: 30px\n            background: transparent\n\n    & ul\n        padding: 10px\n        margin: 15px 0 0 0\n        list-style: none\n        height: calc(100vh - 203px)\n        overflow-y: scroll\n\n        & .active\n            opacity: 1\n            &:hover\n                background: none\n\n        & li\n            opacity: .5\n            border-bottom: 1px solid #d3d3d3\n            padding: 10px 0\n            display: flex\n            cursor: pointer\n\n            & img\n                width: 50px\n                height: 50px\n                margin: 0 25px\n                border-radius: 50rem\n\n            & .text\n                & h6\n                    font-weight: bold\n                    padding: 0\n                    margin: 0\n\n            &:hover\n                opacity: 1\n                background: #f6f6f6\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
